<template>
    <div class="newestArticle">
        <span class="title">{{title}}</span>
        <div class="line"></div>
        <div class="split"></div>
        <div class="article">
            <div class="picture fl">
                <img src="static/img/1.jpg"/>
            </div>
            <div class="content fl">
                <div class="detail">
                    <a href="index.html">没有时间轴的流水</a><br>
                    <label>都市的生活总是最终导向忙碌，聊天最终也是有一搭没一搭的，大家都知道物是人非，人是情非，是是与非非，便不想再多问。时光榨干了那些年的情怀，剩存那些年的离殇。所以大家都觉得今后的人会懂得自己的用心良苦，而不是曾经的“只有你懂”。</label>
                    <a href="index.html" class="view">[详情]</a>
                </div>
                <div class="more">
                    <label class="fl">2019年10月22日 23:00:22</label>
                    <a class="fr" href="javascript:void(0)">赞(0)</a>
                    <a class="fr" href="javascript:void(0)">浏览(0)</a>
                </div>
            </div>
        </div>
        <div class="split"></div>
        <div class="article">
            <div class="picture fl">
                <img src="static/img/2.jpg"/>
            </div>
            <div class="content fl">
                <div class="detail">
                    <a href="index.html">没有时间轴的流水</a><br>
                    <label>都市的生活总是最终导向忙碌，聊天最终也是有一搭没一搭的，大家都知道物是人非，人是情非，是是与非非，便不想再多问。时光榨干了那些年的情怀，剩存那些年的离殇。所以大家都觉得今后的人会懂得自己的用心良苦，而不是曾经的“只有你懂”。</label>
                    <a href="index.html" class="view">[详情]</a>
                </div>
                <div class="more">
                    <label class="fl">2019年10月22日 23:00:22</label>
                    <a class="fr" href="javascript:void(0)">赞(0)</a>
                    <a class="fr" href="javascript:void(0)">浏览(0)</a>
                </div>
            </div>
        </div>
        <div class="split"></div>
        <div class="article">
            <div class="picture fl">
                <img src="static/img/3.jpg"/>
            </div>
            <div class="content fl">
                <div class="detail">
                    <a href="index.html">没有时间轴的流水</a><br>
                    <label>都市的生活总是最终导向忙碌，聊天最终也是有一搭没一搭的，大家都知道物是人非，人是情非，是是与非非，便不想再多问。时光榨干了那些年的情怀，剩存那些年的离殇。所以大家都觉得今后的人会懂得自己的用心良苦，而不是曾经的“只有你懂”。</label>
                    <a href="index.html" class="view">[详情]</a>
                </div>
                <div class="more">
                    <label class="fl">2019年10月22日 23:00:22</label>
                    <a class="fr" href="javascript:void(0)">赞(0)</a>
                    <a class="fr" href="javascript:void(0)">浏览(0)</a>
                </div>
            </div>
        </div>
        <div class="split"></div>
        <div class="article">
            <div class="picture fl">
                <img src="static/img/4.jpg"/>
            </div>
            <div class="content fl">
                <div class="detail">
                    <a href="index.html">没有时间轴的流水</a><br>
                    <label>都市的生活总是最终导向忙碌，聊天最终也是有一搭没一搭的，大家都知道物是人非，人是情非，是是与非非，便不想再多问。时光榨干了那些年的情怀，剩存那些年的离殇。所以大家都觉得今后的人会懂得自己的用心良苦，而不是曾经的“只有你懂”。</label>
                    <a href="index.html" class="view">[详情]</a>
                </div>
                <div class="more">
                    <label class="fl">2019年10月22日 23:00:22</label>
                    <a class="fr" href="javascript:void(0)">赞(0)</a>
                    <a class="fr" href="javascript:void(0)">浏览(0)</a>
                </div>
            </div>
        </div>
        <div class="split"></div>
        <div class="article">
            <div class="picture fl">
                <img src="static/img/5.jpg"/>
            </div>
            <div class="content fl">
                <div class="detail">
                    <a href="index.html">没有时间轴的流水</a><br>
                    <label>都市的生活总是最终导向忙碌，聊天最终也是有一搭没一搭的，大家都知道物是人非，人是情非，是是与非非，便不想再多问。时光榨干了那些年的情怀，剩存那些年的离殇。所以大家都觉得今后的人会懂得自己的用心良苦，而不是曾经的“只有你懂”。</label>
                    <a href="index.html" class="view">[详情]</a>
                </div>
                <div class="more">
                    <label class="fl">2019年10月22日 23:00:22</label>
                    <a class="fr" href="javascript:void(0)">赞(0)</a>
                    <a class="fr" href="javascript:void(0)">浏览(0)</a>
                </div>
            </div>
        </div>
        <div class="split"></div>
        <div class="article">
            <div class="picture fl">
                <img src="static/img/1.jpg"/>
            </div>
            <div class="content fl">
                <div class="detail">
                    <a href="index.html">没有时间轴的流水</a><br>
                    <label>都市的生活总是最终导向忙碌，聊天最终也是有一搭没一搭的，大家都知道物是人非，人是情非，是是与非非，便不想再多问。时光榨干了那些年的情怀，剩存那些年的离殇。所以大家都觉得今后的人会懂得自己的用心良苦，而不是曾经的“只有你懂”。</label>
                    <a href="index.html" class="view">[详情]</a>
                </div>
                <div class="more">
                    <label class="fl">2019年10月22日 23:00:22</label>
                    <a class="fr" href="javascript:void(0)">赞(0)</a>
                    <a class="fr" href="javascript:void(0)">浏览(0)</a>
                </div>
            </div>
        </div>
        <div class="split"></div>
        <div class="article">
            <div class="picture fl">
                <img src="static/img/2.jpg"/>
            </div>
            <div class="content fl">
                <div class="detail">
                    <a href="index.html">没有时间轴的流水</a><br>
                    <label>都市的生活总是最终导向忙碌，聊天最终也是有一搭没一搭的，大家都知道物是人非，人是情非，是是与非非，便不想再多问。时光榨干了那些年的情怀，剩存那些年的离殇。所以大家都觉得今后的人会懂得自己的用心良苦，而不是曾经的“只有你懂”。</label>
                    <a href="index.html" class="view">[详情]</a>
                </div>
                <div class="more">
                    <label class="fl">2019年10月22日 23:00:22</label>
                    <a class="fr" href="javascript:void(0)">赞(0)</a>
                    <a class="fr" href="javascript:void(0)">浏览(0)</a>
                </div>
            </div>
        </div>
        <div class="split"></div>
        <div class="article">
            <div class="picture fl">
                <img src="static/img/3.jpg"/>
            </div>
            <div class="content fl">
                <div class="detail">
                    <a href="index.html">没有时间轴的流水</a><br>
                    <label>都市的生活总是最终导向忙碌，聊天最终也是有一搭没一搭的，大家都知道物是人非，人是情非，是是与非非，便不想再多问。时光榨干了那些年的情怀，剩存那些年的离殇。所以大家都觉得今后的人会懂得自己的用心良苦，而不是曾经的“只有你懂”。</label>
                    <a href="index.html" class="view">[详情]</a>
                </div>
                <div class="more">
                    <label class="fl">2019年10月22日 23:00:22</label>
                    <a class="fr" href="javascript:void(0)">赞(0)</a>
                    <a class="fr" href="javascript:void(0)">浏览(0)</a>
                </div>
            </div>
        </div>
        <div class="split"></div>
        <div class="article">
            <div class="picture fl">
                <img src="static/img/4.jpg"/>
            </div>
            <div class="content fl">
                <div class="detail">
                    <a href="index.html">没有时间轴的流水</a><br>
                    <label>都市的生活总是最终导向忙碌，聊天最终也是有一搭没一搭的，大家都知道物是人非，人是情非，是是与非非，便不想再多问。时光榨干了那些年的情怀，剩存那些年的离殇。所以大家都觉得今后的人会懂得自己的用心良苦，而不是曾经的“只有你懂”。</label>
                    <a href="index.html" class="view">[详情]</a>
                </div>
                <div class="more">
                    <label class="fl">2019年10月22日 23:00:22</label>
                    <a class="fr" href="javascript:void(0)">赞(0)</a>
                    <a class="fr" href="javascript:void(0)">浏览(0)</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            required:false,
            default:'浮云流水'
        }
    },
    data (){
        return {
            
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ArticleList.vue